import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';

import { InputModule } from '@app/modules/ui-components/components/input/input.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { InputErrorModule } from '@ui-components/components/input-error/input-error.module';

import { RadioButtonDropdownComponent } from './radio-button-dropdown.component';
import { IconModule } from '../icon/icon.module';
import { RadioButtonModule } from '../radio-button/radio-button.module';

@NgModule({
  declarations: [RadioButtonDropdownComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    RadioButtonModule,
    ReactiveFormsModule,
    IconModule,
    MatButtonModule,
    InputModule,
    NgSelectModule,
    PipesModule,
    InputErrorModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
  ],
  exports: [RadioButtonDropdownComponent],
})
export class RadioButtonDropdownModule {}
